import { render, staticRenderFns } from "./project-detail-history.vue?vue&type=template&id=332ff8e8&scoped=true&"
import script from "./project-detail-history.vue?vue&type=script&lang=js&"
export * from "./project-detail-history.vue?vue&type=script&lang=js&"
import style0 from "./project-detail-history.vue?vue&type=style&index=0&id=332ff8e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332ff8e8",
  null
  
)

export default component.exports